import Axios from 'axios';
import { IV2FilterPayload } from 'components/AssetFilter/functions/V2FilterPayload';
import { useState } from 'react';
import { PagedQueryParams, ServerSideGrid } from '../../components/grids/AgGrid/ServerSideGrid';
import {
  BeaconReadingsCellRenderer,
  LinkCellRenderer,
  OnlineStatusCellRenderer,
  PlacesCellRenderer,
} from '../../components/grids/index';
import { assetCSVFormat } from '../../components/grids/AgGrid/FormatCSV';
import { AssetListModel } from '../../models/AssetListModel';
import { PagedModel } from '../../models/PagedModel';
import { Api, authService } from '../../services';
import { handleTimeoutApiError } from '../../utils/handleTimeoutApiError';
import { assetColumnDefs } from './columnDefs';

export function AssetListContainer<T>() {
  const [rowData, setRowData] = useState<any>(new PagedModel<T>());
  const [csvData, setCsvData] = useState<any>(new PagedModel<T>());
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const id = 'Assets';
  const cancelToken = Api.CancelToken;
  let fetchDataCancel;

  const assetFilters = authService
    .ensureAssetFiltersInLocalStorage()
    .concat(JSON.parse(localStorage.getItem('tempFilters') || '[]'));

  const fetchData = async (payload?: IV2FilterPayload, csvExport?: boolean) => {
    if (fetchDataCancel !== null && typeof fetchDataCancel === 'function') {
      fetchDataCancel();
      fetchDataCancel = null;
    }
    setIsLoading(true);

    const endpoint = csvExport ? `/v2/assets/filter/export` : `/v2/assets/filter/`;

    Api.post(endpoint, payload, {
      cancelToken: new cancelToken(function executor(c) {
        fetchDataCancel = c;
      }),
      headers: {
        Accept: 'application/json', // Optional, default is JSON but safe to be explicit
      },
    })
      .then((data) => {
        const resp = data.data;
        if (csvExport) {
          setCsvData(assetCSVFormat(resp));
        } else {
          setRowData(resp);
        }
      })
      .catch((e) => {
        if (!Axios.isCancel(e)) {
          console.error(e);
        }
        handleTimeoutApiError(e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <ServerSideGrid<AssetListModel>
      id={id}
      initQueryParams={new PagedQueryParams()}
      assetFilters={assetFilters}
      columnDefs={assetColumnDefs}
      handleFetchData={fetchData}
      rowData={rowData}
      csvData={csvData}
      csvFileName="Asset_Export"
      isLoading={isLoading}
      filterControl={true}
      disabledFilters={['all', 'device id', 'battery value']}
      searchControl={true}
      viewingControl={true}
      pagerControl={true}
      exportControl={true}
      gridProps={{
        frameworkComponents: {
          LinkCellRenderer,
          OnlineStatusCellRenderer,
          BeaconReadingsCellRenderer,
          PlacesCellRenderer,
        },
      }}
      csvHeaders={[
        'id',
        'name',
        'created',
        'assetType',
        'movementThreshold',
        'lastCheckIn',
        'beacons',
        'keywords',
        'location',
        'gpsLocation',
        'identifiers',
        'scans',
        'status',
        'favorite',
        'locationBeaconId',
        'preSignedImageUrl',
      ]}
    />
  );
}
